<template>
  <v-theme-provider light>
    <div class="section-request-demo grey lighten-4 grey--text text--darken-3 py-12">
      <v-container class="py-12">
        <!-- <v-row class="flex-column"> -->
        <!-- <v-row style="flex-wrap: wrap;"> -->
        <v-row>
          <v-col sm="6" style="flex-basis: 50%">
            <p class="display-1"><v-icon class="blink" color="primary">mdi-color-helper</v-icon>Try PatrowlHears free for 7 days</p>
            <!-- <p style="margin-left: 26px;"> -->
            <p>
            Before your 7-day trial begins, we’ll provide you with a free, personalized 15-minutes onboarding call with one of our cybersecurity experts. They’ll help you get the most out of the Patrowl products by showing you how to:
            </p>

            <!-- <dl style="margin-left: 24px;"> -->
            <dl>
              <dd><v-icon>mdi-chevron-right</v-icon>Continuously monitor your assets and risk exposure</dd>
              <dd><v-icon>mdi-chevron-right</v-icon>Detect, prioritize and remediate vulnerabilities</dd>
              <dd><v-icon>mdi-chevron-right</v-icon>Instansly check your cybersecurity posture</dd>
            </dl>

            <p class="display-1 pt-10"><v-icon class="blink" color="primary">mdi-color-helper</v-icon>Want more ?</p>
            <p>
            <dl>
              <dd class="font-weight-bold"><v-icon>mdi-chevron-right</v-icon>Contact us: sales@patrowl.io</dd>
              <dd class="font-weight-bold"><v-icon>mdi-chevron-right</v-icon>Support: getsupport@patrowl.io</dd>
              <!-- <dd><v-icon>mdi-chevron-right</v-icon>Blog: <a href="https://patrowl.ghost.io">https://patrowl.ghost.io</a></dd> -->
            </dl>
          </v-col>
          <v-col sm="6" style="flex-basis: 50%">
            <v-card>
              <v-card-title>
                Get in touch
              </v-card-title>
              <v-card-text>
                <v-form
                  ref="contactform"
                  v-model="valid"
                  lazy-validation
                  >
                  <v-text-field
                    v-model="firstname"
                    :rules="nameRules"
                    label="Firstname (Required)"
                    name="FNAME"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="lastname"
                    :rules="nameRules"
                    label="Lastname (Required)"
                    name="LNAME"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail (Required)"
                    name="EMAIL"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="company"
                    :rules="orgRules"
                    label="Organization or Company name (Required)"
                    name="MMERGE2"
                    required
                  ></v-text-field>
                  <VuePhoneNumberInput
                    v-model="phone"
                    name="PHONE"
                    :translations="{phoneNumberLabel: 'Phone number (optional)'}"
                    />
                  <v-checkbox
                    v-model="optin_cbx"
                    label="Yes, I want news for you (sometimes only !)"
                  ></v-checkbox>
                  <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="validate"
                  >Let's go !
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-snackbar v-model="snack" :timeout="snackTimeout" :color="snackColor" dense>
        {{ snackText }}
        <v-btn text @click="snack = false">Close</v-btn>
      </v-snackbar>
    </div>
  </v-theme-provider>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import axios from 'axios';
export default {
  name: "SecRequestDemo",
  components: {
    VuePhoneNumberInput
  },
  data: () => ({
    valid: true,
    captcha_token: '',
    firstname: '',
    lastname: '',
    company: '',
    email: '',
    phone: '',
    optin_cbx: true,
    nameRules: [
      v => !!v || 'Name is required',
    ],
    orgRules: [
      v => !!v || 'Organization or Company name is required',
    ],
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    snack: false,
    snackColor: '',
    snackText: '',
    snackTimeout: 30000,
  }),
  mounted() {
    this.recaptcha();
  },
  methods: {
    async recaptcha() {
      await this.$recaptchaLoaded()
       this.captcha_token = await this.$recaptcha('login');
    },
    validate () {
      if (this.valid && this.captcha_token != '') {
        let formdata = {
          'firstname': this.firstname,
          'lastname': this.lastname,
          'email': this.email,
          'phone': this.phone,
          'company': this.company,
          'g-recaptcha-response': this.captcha_token,
        };

        axios.post("/api/public/contacts/add", formdata).then(response => {
            if (response && response.status === 200) {
              this.snack = true;
              this.snackColor = 'success';
              this.snackText = 'Thank you ! You will be contacted soon !';
            }
        }).catch(() => {
          this.snack = true;
          this.snackColor = 'error';
          this.snackText = 'Huh! Something goes wrong in the contact form :/';
        })
      }
    },
  },
};
</script>
